/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from 'purify-ts';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as utils from '@/utils';
export default tsx.componentFactoryOf().create({
    name: 'form-group',
    functional: true,
    props: {
        controls: p.ofType().required,
        label: p(String).required,
        description: p(String).optional,
    },
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    render(h, ctx) {
        const maybeErr = ctx.props.controls
            .swap()
            .toMaybe()
            .map(err => {
            if (err instanceof utils.AggregateError) {
                return err.errors;
            }
            return utils.ensureArray(err);
        })
            .map(errs => (<p class="mb-0">{errs.map(err => utils.getErrorMessage(err)).join(' ')}</p>));
        const maybeDesc = Maybe.fromNullable(ctx.props.description ?? ctx.scopedSlots.description?.({}));
        return (<b-form-group state={maybeErr.isNothing()} label={ctx.props.label} scopedSlots={{
                'invalid-feedback': () => maybeErr.orDefaultLazy(() => utils.emptyVNode()),
            }}>
                {utils.ifJustOrEmpty(maybeDesc, desc => (<template slot="description">{desc}</template>))}
                {ctx.slots().default}
            </b-form-group>);
    },
});
